import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const updateClinicAddress = (
  clinicId: number,
  address: string,
  zipcode: string,
  city_id: number
): Promise<any> => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.PUT,
    path: `/api/v1/clinics/clinics/${clinicId}`,
    body: {
      clinic: {
        address,
        zipcode,
        city_id,
      },
    },
  });
};

export default updateClinicAddress;
